import { render, staticRenderFns } from "./DischargeBeds.vue?vue&type=template&id=5c2ec537&scoped=true&"
import script from "./DischargeBeds.vue?vue&type=script&lang=js&"
export * from "./DischargeBeds.vue?vue&type=script&lang=js&"
import style0 from "./DischargeBeds.vue?vue&type=style&index=0&id=5c2ec537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2ec537",
  null
  
)

export default component.exports